import React from 'react';

const SocialnePidpriyemnictvo = () => {
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414]">Соціальне підприємництво</h1>
        <div className="text-justify hyphens-auto ">
          <div className="pt-3 pb-3">
            Протягом історії двигуном соціальних інновацій була Церква. Християнські громади засновували школи, лікарні та хоспіси, щоб прославляти Бога. Монастирі були місцем, де зароджувалися соціальні реформи: вони створювали стійкі методи ведення сільського господарства, вдосконалювали споживчі товари та прагнули будувати спільноти, які не обтяжували бідних, а водночас моделювали спосіб життя, гідний називатися християнським.
          </div>
          <div className="pt-3 pb-3 font-semibold">
            Що таке соціальне підприємництво? Яка його основна місія?
          </div>
          <div className="pt-3 pb-3  pt-3 pb-3 border-l-4 border-[#A81414] pl-6">
            Соціальне підприємництво — це підприємницька діяльність, покликана вирішувати соціальні проблеми та задовольняти потреби суспільства. Можна сказати, що це унікальна можливість поєднати соціальну місію з бажанням заробляти, надавати послуги та продавати товари. Ще донедавна вважалося, що неможливо поєднати альтруїстичні ідеї та суто практичні напрями, але суспільство знайшло вихід із цієї дилеми саме в соціальному підприємництві.
          </div>
          <div className="pt-3 pb-3">
            Основна відмінність соціального підприємства від класичного полягає в його меті. У першому випадку підприємство створюється для вирішення соціальних завдань, тоді як у другому — для отримання прибутку.
          </div>
          <div className="pt-3 pb-3">
            Для звичайного бізнесу соціальна діяльність є побічною — спеціальні фонди створюються лише після накопичення надлишків прибутку. Для соціального підприємництва це, навпаки, основний напрям діяльності. Якщо бізнес систематично віддає 10 % доходу на соціальні потреби, це ще не означає, що він є соціальним. У такій ситуації йдеться радше про прояв корпоративної соціальної відповідальності, а не про соціальне підприємництво як таке.
          </div>
          <div className="pt-3 pb-3">
            Сьогодні в Україні, на жаль, ця діяльність ще не легалізована, тобто юридично не визнана у правовому полі. Попри це, соціальне підприємництво існує та досить успішно розвивається як за кордоном, так і в Україні.
          </div>
          <div className="pt-3 pb-3">
            Салезіянське Згромадження отця Боско в УГКЦ успішно розвиває соціальне підприємництво з метою підтримки дітей-сиріт, душпастирських ініціатив у сфері виховання, діяльності ораторійних центрів, професійної та загальної освіти.
          </div>
          <div className="pt-3 pb-3">
            Центр Боско є одним із прикладів соціального підприємництва, де чітко видно виховну та пасторальну діяльність. До нього належать Молодіжний навчальний центр святого Івана Боско, Родинний дім "Покрова", колегіум для студентів та ФК «Покрова».
            Соціальне підприємництво тут має два виміри:
          </div>
          <div className="pt-3 pb-3">
             • по-перше — це створення робочих місць для сотень осіб, зокрема соціально вразливих;
          </div>
          <div className="pt-3 pb-3">
             • по-друге — це діяльність у конкретних напрямках: хлібопекарня, кондитерська, кухня, пральня, столярна майстерня, готель, послуги СТО та спортивні структури.
          </div>
          <div className="pt-3 pb-3">
            Кошти, отримані від цих структур, скеровуються на розвиток виховної діяльності.
          </div>
        </div>
      </div>
    </>
  );
};

export default SocialnePidpriyemnictvo;
